import { useTranslation } from "react-i18next";

export const Forbidden = () => {
  const { t } = useTranslation();
  return <div>{t('forbidden')}</div>;
};
